import type { CellFailureProps, CellSuccessProps } from '@cedarjs/web'
import { LinearProgress } from '@mui/material'
import type { FindTankBySiteQuery, FindTankBySiteQueryVariables } from 'types/graphql'
import SubHeaderTank from '../SubHeaderTank/SubHeaderTank'

// export const beforeQuery = ({ idSite, date, canHostBatch }) => {

//   return { variables: { idSite, date, canHostBatch } }
// }
export const QUERY = gql`
  query FindTankBySiteQuery($idSite: Int, $date: Date) {
    tanksBySite(idSite: $idSite, date: $date) {
      id
      idSite
      idWater
      name
      shortName
      line
      idTankType
      lastReview {
        state
      }
      tank_type {
        id
        name
        description
        canHostBatch
      }

      lastBatchTransfer {
        batch {
          id
        }
      }
    }
  }
`

export const Loading = () => {
  return (
    <div className="flex w-full h-14 md:h-24 items-center justify-around px-4 py-2 dark:bg-black/20 bg-slate-200/75 backdrop-blur-xl shadow-md relative z-20">
      <LinearProgress />
    </div>
  )
}

export const Empty = () => {
  return (
    <div className="flex w-full h-14 md:h-24 items-center justify-around px-4 py-2 dark:bg-black/20 bg-slate-200/75 backdrop-blur-xl shadow-md relative z-20">
      <LinearProgress />
    </div>
  )
}

export const Failure = ({
  error,
}: CellFailureProps<FindTankBySiteQueryVariables>) => (
  <div className="flex w-full h-14 md:h-24 items-center justify-around px-4 py-2 dark:bg-black/20 bg-slate-200/75 backdrop-blur-xl shadow-md relative z-20"/>
)

export const Success = ({
  tanksBySite,
  canHostBatch
}: CellSuccessProps<FindTankBySiteQuery, FindTankBySiteQueryVariables> &{canHostBatch: boolean}) => {
    return (
      <div>
        <SubHeaderTank tanks={tanksBySite} canHostBatch={canHostBatch}/>
      </div>
    )
}
